<template>
  <VWidget
    :title="$t('Order Items')"
    class="mb-4"
  >
    <div slot="widget-header-action">
      <v-btn
        small
        color="primary"
        class="text-uppercase"
        @click="$emit('add-item')"
      >
        {{ $t('Add Item') }}
      </v-btn>
    </div>
    <v-layout
      slot="widget-content"
      row
      wrap
    >
      <v-flex xs12>
        <v-layout
          row
          wrap
        >
          <v-flex
            xs12
          >
            <v-layout
              v-for="item in order.items"
              :key="item.id"
              row
              wrap
            >
              <v-flex
                xs2
                class="pt-1 pl-4"
              >
                <v-img
                  :src="$helpers.imageFrom(item, 'tiny')"
                  aspect-ratio="1"
                  width="60"
                />
              </v-flex>
              <v-flex
                xs7
              >
                <v-layout
                  row
                  wrap>
                  <v-flex xs6>
                    <div class="subheading info--text">
                      {{ item.name }} <span class="subheading ml-1">{{ item.real_price | money }}</span>
                    </div>
                    <div class="text--secondary">
                      {{ $t('SKU:') }} {{ item.sku }}
                    </div>
                    <div
                      v-if="item.components && item.components.length"
                      class="mt-2">
                      <div
                        v-for="component in item.components"
                        :key="component.key"
                        class="text-secondary font-weight-light caption"><span>{{ component.quantity }}x </span>
                        <router-link
                          :to="{
                            name: 'single-product',
                            params: { id: component.id }
                          }"
                          class="text-no-wrap"
                        >
                          {{ component.name }}
                      </router-link></div>
                    </div>

                    <line-item-extras
                      v-if="item.extras"
                      :extras="item.extras"
                      class="mt-2"
                    />
                  </v-flex>

                  <v-flex
                    v-if="item.tier_price"
                    xs6>
                    <item-tier-breakdown :item="item"/>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex
                xs2
              >
                <CountIncrement
                  v-model="item.quantity"
                  :min="1"
                  :max="item.max || undefined"
                  :step="1"
                  @input="$emit('item-updated', item.id)"
                />
              </v-flex>
              <v-flex
                xs1
                class="align-self-center"
              >
                <v-btn
                  icon
                  small
                  color="error"
                  @click="$emit('item-removed', item.id)"
                >
                  <v-icon small>delete</v-icon>
                </v-btn>
              </v-flex>
              <OrderDraftItemNotes
                :order="order"
                :item="item"
              />
              <v-flex xs12>
                <v-divider />
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </VWidget>
</template>

<script>

import CountIncrement from '@/components/CountIncrement'
import OrderDraftItemNotes from '@/modules/Orders/components/OrderDraft/Items/OrderDraftItemNotes'
import LineItemExtras from '@/modules/Orders/components/Items/LineItemExtras'
import ItemTiers from '@/modules/Orders/components/Items/ItemTiers'
import ItemTiersList from '@/modules/Orders/components/Items/ItemTiersList'
import ItemTierBreakdown from '@/modules/Orders/components/Items/ItemTierBreakdown'

export default {
  name: 'OrderDraftItems',

  components: {
    ItemTierBreakdown,
    ItemTiersList,
    ItemTiers,
    LineItemExtras,
    CountIncrement,
    OrderDraftItemNotes
  },

  props: {
    order: {
      type: Object,
      required: true
    }
  }
}
</script>
